<template>
  <div class="customField pb-4">
    <div
      class="v-label mb-2"
      :class="{
        'v-label--is-disabled': !editFlag,
        'theme--light': !this.$vuetify.theme.dark,
        'theme--dark': this.$vuetify.theme.dark,
      }"
    >
      10. What are the names of your 2-3 largest employers
      (organizations > 3000 employees globally?)
    </div>

    <v-container class="pa-0">
      <v-row
        align="center"
        justify="start"
      >
        <span
          v-for="(employer, key) in largestEmployers"
          :key="`employer${key}`"
          class="d-flex pr-0 pb-0 flex-wrap"
        >
          <v-chip
            class="employerChip"
            close
            :disabled="!editFlag"
            @click:close="removeEmployer(key)"
          >
            {{ employer }}
          </v-chip>
        </span>

        <v-col
          cols="12"
        >
          <v-text-field
            v-model="inputEmployers"
            placeholder="Input employer name"
            clearable
            counter="128"
            maxlength="128"
            :disabled="!editFlag"
            class="pt-0"
            @keydown.enter="addEmployer"
          >
            <template #append-outer>
              <v-btn
                v-show="editFlag"
                color="primary lighten-2"
                small
                :disabled="!editFlag"
                @click="addEmployer"
              >
                Add
              </v-btn>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'Question10',

  props: {
    editFlag: {
      type: Boolean,
      default: false,
    },

    largestEmployers: {
      type: Array,
      default: null,
    },
  },

  data: () => ({
    inputEmployers: '',
  }),

  methods: {
    addEmployer() {
      if (this.inputEmployers !== '') {
        const addData = [...this.largestEmployers, this.inputEmployers];
        this.$emit('update:largestEmployers', addData);
        this.inputEmployers = '';
      }
    },

    removeEmployer(index) {
      const removeData = this.largestEmployers.filter((el, key) => index !== key);
      this.$emit('update:largestEmployers', removeData);
    },
  },
};
</script>

<style lang="scss">
  .employerChip {
    &.v-chip {
      word-break: break-word;
      white-space: normal;
      height: 100%;
      padding: 4px 12px;
      margin: 5px 4px !important;
    }
  }
</style>
